import { Row } from 'react-bootstrap';
import { styled } from 'styletron-react';

const EntryRow = styled(Row, {
  backgroundColor: 'white',
  paddingTop: '9px',
  paddingBottom: '9px',
  '@media (max-width: 767px)': {
    paddingTop: '14px',
    paddingBottom: '14px'
  }
});

export default EntryRow;
